// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
// import api from "../api/axiosInstance";

// const EventDetailsPage = ({ events }) => {
//   const { id } = useParams();
//   // const event = events.find((e) => e.id.toString() === id);
//   const [event, setEvent] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const [open, setOpen] = useState(false);
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const fetchEvent = async () => {
//       try {
//         const res = await api.get(`/events/get/by-id/${id}`);
//         setEvent(res.data);
//       } catch (err) {
//         console.error("Failed to fetch event:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEvent();
//   }, [id]);

//   if (loading) return <p>Loading...</p>;
//   if (!event) {
//     return <p className="text-center py-10">Event not found.</p>;
//   }

//   return (
//     <section className="max-w-6xl mx-auto py-16 px-6">
//       {/* Title */}
//       <h1 className="text-4xl font-bold mb-2">{event?.title}</h1>
//       {/* <p className="text-gray-500 mb-8">{event?.date}</p> */}

//       {/* Images Grid */}
//       {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {event.imageUrls.map((img, idx) => (
//           <img
//             key={idx}
//             src={img}
//             alt={`${event.title} - ${idx + 1}`}
//             className="w-full h-[250px] object-cover rounded-xl shadow-md hover:scale-105 transition-transform cursor-pointer"
//             onClick={() => {
//               setIndex(idx);
//               setOpen(true);
//             }}
//           />
//         ))}
//       </div> */}
//       {event?.imageUrls?.length > 0 && (
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//           {event.imageUrls.map((url, index) => (
//             <img
//               key={index}
//               src={url}
//               alt={`${event.title} - ${index + 1}`}
//               className="w-full h-[300px] object-cover rounded-lg"
//             />
//           ))}
//         </div>
//       )}

//       {/* Lightbox Viewer */}
//       <Lightbox
//         open={open}
//         close={() => setOpen(false)}
//         index={index}
//         slides={event.imageUrls.map((img) => ({ src: img }))}
//         carousel={{ finite: false }} // loop through images
//       />
//     </section>
//   );
// };

// export default EventDetailsPage;
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
// import api from "../api/axiosInstance";

// const EventDetailsPage = () => {
//   const { id } = useParams();
//   const [event, setEvent] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const [open, setOpen] = useState(false);
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const fetchEvent = async () => {
//       try {
//         const res = await api.get(`/events/get/by-id/${id}`);
//         setEvent(res.data);
//       } catch (err) {
//         console.error("Failed to fetch event:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEvent();
//   }, [id]);

//   if (loading) return <p>Loading...</p>;
//   if (!event) return <p className="text-center py-10">Event not found.</p>;

//   const images = event?.imageUrls || [];

//   return (
//     <section className="max-w-6xl mx-auto py-16 px-6">
//       {/* Title */}
//       <h1 className="text-4xl font-bold mb-2">{event.title}</h1>

//       {/* Images Grid */}
//       {images.length > 0 && (
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//           {images.map((img, idx) => (
//             <img
//               key={idx}
//               src={img}
//               alt={`${event.title} - ${idx + 1}`}
//               className="w-full h-[250px] object-cover rounded-xl shadow-md hover:scale-105 transition-transform cursor-pointer"
//               onClick={() => {
//                 setIndex(idx); // set clicked image index
//                 setOpen(true); // open lightbox
//               }}
//             />
//           ))}
//         </div>
//       )}

//       {/* Lightbox Viewer */}
//       {images.length > 0 && (
//         <Lightbox
//           open={open}
//           close={() => setOpen(false)}
//           index={index}
//           slides={images.map((src) => ({ src }))}
//           carousel={{ finite: false }} // loop through images
//         />
//       )}
//     </section>
//   );
// };

// export default EventDetailsPage;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import api from "../api/axiosInstance";

const EventDetailsPage = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const res = await api.get(`/events/get/by-id/${id}`);
        setEvent(res.data);
      } catch (err) {
        console.error("Failed to fetch event:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!event) return <p className="text-center py-10">Event not found.</p>;

  const images = event?.imageUrls || [];

  // Format date nicely
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <section className="max-w-6xl mx-auto py-16 px-6">
      {/* Title */}
      <h1 className="text-4xl font-bold mb-2">{event.title}</h1>

      {/* Dates */}
      <p className="text-lg text-gray-600 mb-8">
        {event.startDate === event.endDate
          ? `Date: ${formatDate(event.startDate)}`
          : `From ${formatDate(event.startDate)} to ${formatDate(
              event.endDate
            )}`}
      </p>

      {/* Images Grid */}
      {images.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`${event.title} - ${idx + 1}`}
              className="w-full h-[250px] object-cover rounded-xl shadow-md hover:scale-105 transition-transform cursor-pointer"
              onClick={() => {
                setIndex(idx);
                setOpen(true);
              }}
            />
          ))}
        </div>
      )}

      {/* Lightbox Viewer */}
      {images.length > 0 && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          index={index}
          slides={images.map((src) => ({ src }))}
          carousel={{ finite: false }}
        />
      )}
    </section>
  );
};

export default EventDetailsPage;
